import { render, staticRenderFns } from "./AeAddressPanel.vue?vue&type=template&id=36518e5c&scoped=true"
import script from "./AeAddressPanel.vue?vue&type=script&lang=js"
export * from "./AeAddressPanel.vue?vue&type=script&lang=js"
import style0 from "./AeAddressPanel.vue?vue&type=style&index=0&id=36518e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36518e5c",
  null
  
)

export default component.exports